"use strict";

exports.__esModule = true;
exports.CommonItemContainer = exports.CommonItemContainerNotConnected = void 0;

var _react = _interopRequireDefault(require("react"));

var _galleryActions = require("../../actions/galleryActions.js");

var _itemViewActions = require("../../actions/itemViewActions.js");

var _reactRedux = require("react-redux");

var _windowWrapper = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/sdk/windowWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var CommonItemContainerNotConnected = function CommonItemContainerNotConnected(ComposedComponent) {
  var InnerComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(InnerComponent, _React$Component);

    function InnerComponent(props, context) {
      var _this;

      _this = _React$Component.call(this, props, context) || this;
      _this.updateLoveCount = _this.updateLoveCount.bind(_assertThisInitialized(_this));
      _this.state = {
        isLoved: _this.props.actions.itemActions.isLoved(props.photoId),
        loveCount: 0
      };
      return _this;
    }

    var _proto = InnerComponent.prototype;

    _proto.componentDidMount = function componentDidMount() {
      _windowWrapper["default"].addEventListener('love_count_fetched', this.updateLoveCount);
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      _windowWrapper["default"].removeEventListener('love_count_fetched', this.updateLoveCount);
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var photoId = nextProps.photoId;
      this.setState({
        isLoved: this.props.actions.itemActions.isLoved(photoId),
        loveCount: this.props.actions.itemActions.getLoveCount(photoId)
      });
    };

    _proto.updateLoveCount = function updateLoveCount() {
      this.setState({
        loveCount: this.props.actions.itemActions.getLoveCount(this.props.photoId)
      });
    };

    _proto.toggleLove = function toggleLove() {
      this.props.actions.itemActions.postLoveActivity(this.props);
      this.props.actions.itemActions.toggleLove(this.props.photoId, 'gallery');
      this.setState({
        isLoved: !this.state.isLoved
      });
    };

    _proto.render = function render() {
      var photoId = this.props.photoId;
      var _this$state = this.state,
          isLoved = _this$state.isLoved,
          loveCount = _this$state.loveCount;
      return _react["default"].createElement(ComposedComponent, _extends({}, this.props, {
        love: {
          isLoved: isLoved,
          count: loveCount + (isLoved ? 1 : 0),
          toggleLove: this.toggleLove.bind(this)
        }
      }));
    };

    return InnerComponent;
  }(_react["default"].Component);

  return InnerComponent;
};

exports.CommonItemContainerNotConnected = CommonItemContainerNotConnected;

var CommonItemContainer = function CommonItemContainer(ComposedComponent) {
  var commonItemContainerNotConnected = CommonItemContainerNotConnected(ComposedComponent);

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var galleryState = state.gallery || {};
    return {
      playing: galleryState.videoIndexPlay === ownProps.idx,
      documentHeight: galleryState.documentHeight,
      previewHover: galleryState.previewHover
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps, {
    videoEnded: _galleryActions.videoEnded,
    videoAdded: _galleryActions.videoAdded,
    videoRemoved: _galleryActions.videoRemoved,
    playVideo: _itemViewActions.playVideo,
    pauseVideo: _itemViewActions.pauseVideo
  })(commonItemContainerNotConnected);
};

exports.CommonItemContainer = CommonItemContainer;